import React from "react";
import InspectionRouter from './Inspection/Router';
export { getFields, getReplyFields } from './Inspection/Router';

export default function InspectionSupplierRouter(props){
    return <InspectionRouter {...props} mode='SUPPLIER' />;
}